import { Layout } from "react-grid-layout";

import { MedicalSummarySections } from "../Components/MedicalSummaryConfiguration/MedicalSummaryEnum";

class SummaryLayoutItem {
    public Row: number;
    public Column: number;
    public Width: number;
    public Height: number;
    public Section: MedicalSummarySections;
    public IsHidden: boolean;

    public static toReactGridLayoutItem(layout: SummaryLayoutItem): Layout {
        return {
            x: layout.Row,
            y: layout.Column,
            w: layout.Width,
            h: layout.Height,
            i: layout.Section.toString()
        };
    }

    public static toSummaryLayoutItem(gridLayout: Layout, isHidden: boolean): SummaryLayoutItem {
        return {
            Row: gridLayout.x,
            Column: gridLayout.y,
            Width: gridLayout.w,
            Height: gridLayout.h,
            Section: parseInt(gridLayout.i) as MedicalSummarySections,
            IsHidden: isHidden
        };
    }
}

export { SummaryLayoutItem };
